module.exports = __webpack_public_path__ + "static/media/39.f23aca60.jpg";